/**
 * Safely parses a JSON string with fallback handling
 * @param {string} jsonString - The JSON string to parse
 * @param {*} fallback - The fallback value if parsing fails
 * @returns {*} The parsed object or fallback value
 */
export default function safeJsonParse(jsonString, fallback = null) {
    if (!jsonString || typeof jsonString !== 'string') {
        return fallback;
    }
    try {
        return JSON.parse(jsonString);
    } catch (error) {
        console.warn('Failed to parse JSON string:', error);
        return fallback;
    }
}
